/**
 * Manage search and display when selecting an ats offer to sync with
 */

const onmount = require('onmount');

function mountAtsOfferSyncPage() {
  function search(ev) {
    const searchTerm = (ev.target as any).value.toLowerCase();
    const jobCards = document.querySelectorAll('.job');

    jobCards.forEach((jobCard: any) => {
      const titleElement = jobCard.querySelector('#ats_offer_title');
      const nameElement = jobCard.querySelector('#ats_offer_name');

      const titleText = titleElement ? titleElement.value.toLowerCase() : '';
      const nameText = nameElement ? nameElement.value.toLowerCase() : '';

      // Show the card if either title or name contains the search term
      if (titleText.includes(searchTerm) || nameText.includes(searchTerm)) {
        $(jobCard).slideDown(500);
      } else {
        $(jobCard).slideUp(500);
      }
    });
  }

  const searchBar = document.getElementById('js-searchAtsOffer');

  searchBar.addEventListener('submit', ev => ev.preventDefault());
  searchBar.addEventListener('change', ev => search(ev));
  searchBar.addEventListener('keyup', ev => search(ev));
}

onmount('#js-atsOfferSync', mountAtsOfferSyncPage);
